import { FormHelperText } from '@mui/material';
import * as React from 'react';
import { explisoftService, License } from '@services';
import Wait from '../Wait';
import LicenseRenderer from './license-renderer';

export const LicenseScopeSelector = (props: {
    initialScope?: string[];
    onChange?: (scopes: string[]) => void,
    onScopeChange?: (scope: string, addOrRemove: "add" | "remove") => void
    disabled?: boolean
}) => {
    const { initialScope } = props;
    const [selectedScope, setSelectedScope] = React.useState([]);
    React.useEffect(() => {
        setSelectedScope(initialScope || []);
    }, [initialScope]);
    const [availableLicense, setAvailableLicense] = React.useState<License[]>([]);
    const [loading, setLoading] = React.useState(false);
    const [error, setError] = React.useState('');
    React.useEffect(() => {
        setLoading(true);
        setAvailableLicense([]);
        explisoftService
            .getAvailableLicense()
            .then((data) => {
                setAvailableLicense(data);
            })
            .catch((error) => {
                setError(error.message || 'unable to fetch available license');
            })
            .finally(() => {
                setLoading(false);
            });
    }, []);

    const handleScopeChange = (scopes: string[], license: License) => {
        const otherScopes = selectedScope.filter((scope) => !scope.startsWith(`${license.id}:`));
        setSelectedScope([...otherScopes, ...scopes]);
        props.onChange?.([...otherScopes, ...scopes]);
    };

    const handlScopeModify = (scope: string, addOrRemove: "add" | "remove") => {
        props.onScopeChange?.(scope, addOrRemove);
    }
    return (
        <div>
            {loading && <Wait loading={loading} />}
            {!loading && !error && (
                <div style={{ border: 1 }}>
                    {availableLicense.map((license) => (
                        <div key={license.id} style={{ marginBottom: '10px' }}>
                            <LicenseRenderer
                                license={license}
                                selectedScopes={selectedScope.filter((s) => s.startsWith(`${license.id}:`))}
                                onScopeChange={handleScopeChange}
                                onScopeModify={handlScopeModify}
                                disabled={props.disabled}
                            />
                        </div>
                    ))}
                </div>
            )}
            {!loading && error && (
                <FormHelperText error id="standard-weight-helper-text--register-error">
                    {error}
                </FormHelperText>
            )}
        </div>
    );
};
